module.exports = __webpack_public_path__ + "static/img/use_fund_as_you_choose1.5bb7b35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/use_fund_as_you_choose1.png
// module id = 1812
// module chunks = 5